'use client';
import { styled } from '@mui/material/styles';
import MuiMobileStepper, { MobileStepperProps } from '@mui/material/MobileStepper';

const StyledMobileStepper = styled(MuiMobileStepper)<MobileStepperProps>({
  '& .MuiMobileStepper-root': {
    backgroundColor: '#f4f4f8',
    background: '#f4f4f8',
  },
  '& .MuiMobileStepper-dot.MuiMobileStepper-dotActive.MuiMobileStepper-dot': {
    backgroundColor: '#000',
  },
  '& .MuiMobileStepper-dot.MuiMobileStepper-dot': {
    marginRight: '5px',
  },
});

export const MobileStepperStyled = (props: MobileStepperProps) => <StyledMobileStepper {...props} />;
